"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Services = void 0;
// export type name field to service like 'Spotify', 'Deezer', etc.
exports.Services = [
    "Youtube_Music",
    "Deezer",
    "Youtube_Videos",
    "Soundcloud",
    "Spotify",
    "Google_Play",
    "Amazon_Music",
    "Apple_Music",
];
//# sourceMappingURL=Streaming.js.map